import { requireNativeView, requireOptionalNativeModule } from 'expo'
import type { ComponentType } from 'react'
import type { ColorValue, ViewProps } from 'react-native'

const MODULE_NAME = 'FunkitGlassEffect'

export type GlassStyle = 'clear' | 'regular' | 'none'

export interface GlassViewProps extends ViewProps {
  glassEffectStyle?: GlassStyle
  tintColor?: ColorValue
  isInteractive?: boolean
  colorScheme?: 'auto' | 'light' | 'dark'
  /**
   * Corners follow the enclosing container — the screen, for a full-bleed view
   * (iOS 26 `containerConcentric`). Overrides the fixed radius props.
   */
  concentricCorners?: boolean
  concentricMinimumRadius?: number
}

interface GlassEffectConstants {
  isLiquidGlassAvailable: boolean
  isGlassEffectAPIAvailable: boolean
}

// `null` wherever the SDK's pod isn't linked: Android, web, Expo Go, and a
// host binary built before it upgraded.
const constants = requireOptionalNativeModule<GlassEffectConstants>(MODULE_NAME)

export const isLiquidGlassAvailable =
  constants?.isLiquidGlassAvailable === true &&
  constants.isGlassEffectAPIAvailable === true

export const GlassView: ComponentType<GlassViewProps> | null =
  isLiquidGlassAvailable
    ? requireNativeView<GlassViewProps>(MODULE_NAME, 'GlassView')
    : null
